var render = function render(){var _vm=this,_c=_vm._self._c;return _c('relatorio-risco',{attrs:{"objetivo":"evasao","titulo":"RELATÓRIO DE RISCO DE EVASÃO"}})
}
var staticRenderFns = []

export { render, staticRenderFns }